import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import ComponentPlannerLayer from '../components/ComponentPlannerLayer';

const ComponentPlannerPage = () => {
  return (
    <MasterLayout pageTitle='Component Planner'>
      <ComponentPlannerLayer />
    </MasterLayout>
  );
};

export default ComponentPlannerPage;
